import React, { useEffect, useRef, useState } from "react";
import NavBar from "../../../Components/Navbar/navbar";
import styles from "../../Styles/tables.module.css";
import { HiPencil, HiPlus, HiSearch, HiTrash, HiX } from "react-icons/hi";
import { useLocation, useNavigate } from "react-router";
import axios from "axios";
import { getUser, Url } from "../../../Constants/globals";
import RefreshToken from "../../../Components/RefreshToken/RefreshToken";
import DeleteModal from "../../../Components/DeleteModal/deletemodal";
import Alert from "../../../Components/Alert/alert";
import GoBack from "../../../Components/GoBack/goback";

function Cartoes({ userPermissions }) {

    const location = useLocation();
    const { state } = location;
    const navigate = useNavigate();
    const searchRef = useRef(null);

    const [loadingData, setLoadingData] = useState(true);
    const [deleteCard, setDeleteCard] = useState("");
    const [cards, setCards] = useState([]);
    const [alert, setAlert] = useState("");
    const [isPoppedOut, setIsPoppedOut] = useState(false);
    const [nomeSearch, setNomeSearch] = useState(state?.nomeSearch ? state.nomeSearch : "");
    const [showSearch, setShowSearch] = useState(nomeSearch ? true : false);

    async function getCards(name) {
        try {
            const res = await axios.get(`${Url}/business-cards${name ? `?search=${name}` : ""}`, {
                headers: {
                    Authorization: "Bearer " + getUser().token,
                },
            });
            return res.data;
        }
        catch (err) {
            if (err.request && err.request.status === 401) {
                var newToken = await RefreshToken(err);
                if (newToken) return await getCards(name);
                else window.location.reload();
            }
            else {
                console.error(err);
                return "";
            }
        };
    }

    async function deleteCardFunction(id) {
        try {
            await axios.delete(`${Url}/business-cards/${id}`, {
                headers: {
                    Authorization: "Bearer " + getUser().token,
                },
            });
            return [200, <Alert type={"success"}>Eliminado com sucesso!</Alert>];
        }
        catch (err) {
            if (err.request && err.request.status === 401) {
                var newToken = await RefreshToken(err);
                if (newToken) {
                    return await deleteCardFunction(id);
                } else {
                    window.location.reload();
                }
            }
            else {
                console.error(err);
                return [0, <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao eliminar"}</Alert>];
            }
        };
    }

    async function getAlertDelete(id) {
        if (id) {
            await setAlert("");
            const res = await deleteCardFunction(id);
            setAlert(res[1]);
            assignData();
            return res;
        }
    }

    async function assignData() {
        const thisCardsData = await getCards(nomeSearch);
        setCards(thisCardsData);
        setLoadingData(false);
    }

    const handleSearchContainer = () => {
        if (showSearch) {
            setIsPoppedOut(true);
            setTimeout(() => {
                setShowSearch(false);
                setIsPoppedOut(false);
            }, 280);
        } else {
            setShowSearch(true);
            setTimeout(() => {
                searchRef.current.focus();
            }, 280);
        }
    }

    async function handleSearch(input) {
        if (input === false) {
            setNomeSearch("");
        }
        const searchCardsData = await getCards(input === false ? "" : nomeSearch);
        setCards(searchCardsData);
        navigate(location.pathname, { replace: true, state: { nomeSearch: input === false ? "" : nomeSearch } });
    }

    useEffect(() => {
        assignData();
    }, []);

    return (
        <div className="body">
            {alert}
            {deleteCard}
            <NavBar current={"colaboradores"} setDisappear={setLoadingData} userPermissions={userPermissions} />
            {
                userPermissions?.colaboradores ? <GoBack backRoute={`/colaboradores`} backState={state?.page ? { page: state.page, nomeSearch: state.nomeSearch ?? "" } : {}} /> : ""
            }
            {
                loadingData ? ""
                    :
                    <div style={{ position: "relative" }}>
                        <div className={styles.tableButtons}>
                            <button className={styles.btnAdd} onClick={() => navigate("/cartoes/adicionar")}>
                                <HiPlus size={20} />
                                <p className={styles.textAdd}>Adicionar</p>
                            </button>
                            <button className={`${styles.btnSearch} ${showSearch ? styles.btnSearchActive : ""}`} onClick={() => handleSearchContainer()}>
                                <HiSearch size={20} />
                                <p className={styles.textAdd}>Procurar</p>
                            </button>
                        </div>
                        <div className={styles.content}>
                            {
                                showSearch ?
                                    <div className={`${styles.container} ${showSearch ? styles.popin : ""} ${isPoppedOut ? styles.popout : ""}`}  >
                                        <input
                                            ref={searchRef}
                                            className={styles.searchInput}
                                            onChange={(e) => setNomeSearch(e.target.value)}
                                            placeholder="Procurar cartão"
                                            value={nomeSearch}
                                            onKeyDown={(event) => {
                                                if (event.key === "Enter") handleSearch();
                                            }}
                                        />
                                        <div style={{ backgroundColor: "var(--inputBackground)", display: "flex", borderTopRightRadius: "4px", borderBottomRightRadius: "4px" }}>
                                            <button className={styles.btn} style={{ cursor: "default", marginRight: "0" }} onClick={() => handleSearch(false)}>
                                                <HiX size={16} color="#9c9c9c" />
                                            </button>
                                            <button className={styles.btn} style={{ marginLeft: "0" }} onClick={() => handleSearch()}>
                                                <HiSearch size={18} />
                                            </button>
                                        </div>
                                    </div>
                                    : ""
                            }
                            <div className={styles.table}>
                                <div className={styles.cardsColumn}>
                                    <p>Nome</p>
                                    <p>Empresa</p>
                                    <p>Cargo</p>
                                    <p>Departamento</p>
                                    <p>Ações</p>
                                </div>
                                <div className={styles.scrollContent}>
                                    {
                                        cards.length ?
                                            cards.map((card, index) =>
                                                <div key={index} className={styles.cardsInfo} style={index % 2 !== 0 ? { backgroundColor: "var(--inputBackground)" } : {}}>
                                                    <p title={card.card_holder ? card.card_holder : ""}>
                                                        {card.card_holder ? card.card_holder : "-"}
                                                    </p>
                                                    <p title={card.company?.name ? card.company.name : ""}>
                                                        {card.company?.name ? card.company.name : "-"}
                                                    </p>
                                                    <p title={card.job_title ? card.job_title : ""}>
                                                        {card.job_title ? card.job_title : "-"}
                                                    </p>
                                                    <p title={card.department ? card.department : ""}>
                                                        {card.department ? card.department : "-"}
                                                    </p>
                                                    <div className={styles.actions}>
                                                        <HiPencil
                                                            size={22}
                                                            className={styles.icon}
                                                            onClick={() => navigate("/cartoes/" + card.slug)}
                                                        />
                                                        <HiTrash
                                                            size={22}
                                                            className={styles.icon}
                                                            onClick={() => setDeleteCard(<DeleteModal close={setDeleteCard} objectId={card.id} objectName={` o cartão: ${card.user.full_name}, ${card.company.name}, ${card.job_title}, ${card.department}`} deleteFunction={getAlertDelete} />)}
                                                        />
                                                    </div>
                                                </div>
                                            )
                                            :
                                            <div className={styles.noData}>
                                                <p>Não existem dados</p>
                                            </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
            }
        </div>
    );
}

export default Cartoes;